import { createTheme } from "@mui/material/styles";
import { trustBudTokens } from "./theme/tokens";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: trustBudTokens.colors.brand.navy700,
      dark: trustBudTokens.colors.brand.navy800,
      light: trustBudTokens.colors.brand.navy600,
      contrastText: trustBudTokens.colors.text.inverse,
    },
    secondary: {
      main: trustBudTokens.colors.success.base,
      dark: trustBudTokens.colors.success.strong,
    },
    success: {
      main: trustBudTokens.colors.success.base,
      dark: trustBudTokens.colors.success.strong,
      light: trustBudTokens.colors.success.soft,
      contrastText: trustBudTokens.colors.text.inverse,
    },
    warning: {
      main: trustBudTokens.colors.warning.base,
      dark: trustBudTokens.colors.warning.strong,
      light: trustBudTokens.colors.warning.soft,
      contrastText: trustBudTokens.colors.text.inverse,
    },
    error: {
      main: trustBudTokens.colors.danger.base,
      dark: trustBudTokens.colors.danger.strong,
      light: trustBudTokens.colors.danger.soft,
      contrastText: trustBudTokens.colors.text.inverse,
    },
    text: {
      primary: trustBudTokens.colors.text.primary,
      secondary: trustBudTokens.colors.text.secondary,
    },
    divider: trustBudTokens.colors.border.subtle,
    background: {
      default: trustBudTokens.colors.bg.app,
      paper: trustBudTokens.colors.bg.paper,
    },
  },

  shape: {
    borderRadius: trustBudTokens.radius.sm,
  },

  typography: {
    fontFamily: `"Inter", "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 16,
    h1: {
      fontSize: "3rem",
      fontWeight: 800,
      letterSpacing: 0,
      color: trustBudTokens.colors.text.primary,
    },
    h2: {
      fontSize: "2.4rem",
      fontWeight: 800,
      letterSpacing: 0,
      color: trustBudTokens.colors.text.primary,
    },
    h3: {
      fontSize: "2rem",
      fontWeight: 800,
      letterSpacing: 0,
      color: trustBudTokens.colors.text.primary,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 700,
      letterSpacing: 0,
      color: trustBudTokens.colors.text.primary,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.6,
      color: trustBudTokens.colors.text.secondary,
    },
    body2: {
      fontSize: "0.95rem",
      lineHeight: 1.55,
      color: trustBudTokens.colors.text.secondary,
    },
    caption: {
      fontSize: "0.76rem",
      lineHeight: 1.35,
      letterSpacing: "0.04em",
      color: trustBudTokens.colors.text.muted,
    },
  },
  custom: {
    gradients: {
      hero: "#10233f",
      page: "#f6f8fb",
    },
    radius: {
      marketingCard: trustBudTokens.radius.md,
    },
    shadows: {
      soft: trustBudTokens.shadows.card,
    },
  },

  components: {
    // ✅ Prevent iOS Safari auto-zoom
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 16,
        },
      },
    },

    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontSize: 15,
          textTransform: "none",
          borderRadius: trustBudTokens.radius.md,
          padding: "10px 16px",
          fontWeight: 700,
          letterSpacing: 0,
        },
        containedPrimary: {
          backgroundColor: trustBudTokens.colors.brand.navy700,
          color: trustBudTokens.colors.text.inverse,
          boxShadow: "none",
          "&:hover": {
            backgroundColor: trustBudTokens.colors.brand.navy800,
            boxShadow: "none",
          },
        },
        outlined: {
          borderColor: trustBudTokens.colors.border.muted,
          color: trustBudTokens.colors.text.primary,
          backgroundColor: "rgba(255,255,255,0.72)",
          "&:hover": {
            borderColor: trustBudTokens.colors.brand.navy600,
            backgroundColor: "#ffffff",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          borderRadius: trustBudTokens.radius.md,
          border: `1px solid ${trustBudTokens.colors.border.subtle}`,
          boxShadow: "none",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: trustBudTokens.radius.md,
          fontWeight: 700,
          letterSpacing: 0,
        },
      },
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: 14,
          color: trustBudTokens.colors.text.muted,
        },
      },
    },
  },
});

export default theme;
